import { Component, Vue } from 'vue-property-decorator'

/* 
 * 此逻辑主要处理element ui弹出控件层级过高的问题。
*/

let lock = true
let el: any = null
// const MousedownEvent = new Event('mousedown', { bubbles: true })
// const MouseupEvent = new Event('mouseup', { bubbles: true })
const MousedownEvent = document.createEvent('Events')
MousedownEvent.initEvent('mousedown', true, true)
const MouseupEvent = document.createEvent('Events')
MouseupEvent.initEvent('mouseup', true, true)
const fakeClickOutSide = () => {
    document.dispatchEvent(MousedownEvent)
    document.dispatchEvent(MouseupEvent)
    lock = true // console.log('dispatchEvent');
}
const mousedownHandle = (e: any) => {
    const classList = e.target.classList

    if (classList.contains('el-select__caret') || classList.contains('el-input__inner') || classList.contains('el-select__tags') || classList.contains('el-range-input') || classList.contains('el-range-separator') || classList.contains("el-input__icon")) {
        lock = false
        return
    }
    if (lock) return
    fakeClickOutSide()
}
const mousewheelHandle = (e: any) => {
    // Popup content and scrollbar gutters are inside the control, not an outside scroll.
    const target = e.target instanceof Element ? e.target : null
    if (lock || target?.closest('.el-select-dropdown, .el-cascader__dropdown')) return

    fakeClickOutSide()
}
const eventListener = (type: any) => {
    let h: any = type + 'EventListener';

    el[type + 'EventListener']('mousedown', mousedownHandle);
    (window as any)[h]('mousewheel', mousewheelHandle);
    (window as any)[h]('DOMMouseScroll', mousewheelHandle); // fireFox 3.5+
}

@Component({})
export default class extends Vue {
    mounted() {
        el = this.$root.$el
        el.addFakeClickOutSideEventCount = el.addFakeClickOutSideEventCount || 0;
        (!el.addFakeClickOutSideEventCount) && this.$nextTick(() => {
            eventListener('add')
        })
        el.addFakeClickOutSideEventCount += 1
    }

    destroyed() {
        eventListener('remove')
        el.addFakeClickOutSideEventCount -= 1
    }

}
